import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export const papelFindAll = async() => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/papel/findall', {headers});
}

export const papelInsert = async(usuario) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.post(url + '/v1/papel/insert', usuario, {headers});
  }

  export const papelUpdate = async(usuario) => {
    const headers = { 'Content-Type': 'application/json'};
    return await axios.put(url + '/v1/papel/update', usuario, {headers});
  }
    
  export const papelDelete = async (usuario) =>{
    const headers = { 'Content-Type': 'application/json'};
    return await axios.delete(url + '/v1/papel/delete', {data: usuario}, {headers});
  }
